export const LT_INCOMES_DATA_RECEIVED = 'LT_INCOMES_DATA_RECEIVED'
export const LT_INCOME_SAVED = 'LT_INCOME_SAVED'
export const LT_INCOME_DELETED = 'LT_INCOME_DELETED'
export const LT_INCOME_UNLOADED = 'LT_INCOME_UNLOADED'
